import { ComposerKeyType } from '../../keys';

const composer: ComposerKeyType = {
  singular: 'Композитор',
  composeButton: 'Компонувати',
  composeModalTitle: 'Компонування сцени',
  loading: 'Завантаження композитора…',
  studioRender: 'Рендер',
  aiImageryTool: 'ШІ-інструмент зображень',
  comingSoon: 'Незабаром',
  renderRequested: 'Запит на рендер додано до черги',
  renderRequestFailed: 'Не вдалося запросити рендер',
  requestRender: 'Запросити рендер',
  generatingRender: 'Генерація рендеру…',
  generatingRenderMessage: 'Рендеримо вашу сцену — це займе близько хвилини.',
  createdRenders: 'Рендери',
  backToScene: 'Назад до сцени',
  generationModeCompositeRender: 'композитний рендер',
  generationModeLifestyle: 'лайфстайл',
  generatingLifestyle: 'Генерація лайфстайлу…',
  generatingLifestyleMessage:
    'Генеруємо лайфстайл-зображення — це займе близько хвилини.',
  lifestylePromptPlaceholder: 'Опишіть сцену для генерації з цього рендера...',
  addReferences: 'Додати референси',
  renderCancelled: 'Рендер зупинено',
  backgroundDefault: 'За замовчуванням',
  backgroundBlack: 'Чорний',
  backgroundWhite: 'Білий',
  backgroundGray: 'Сірий',
  backgroundCustom: 'Свій колір',
  backgroundColorPicker: 'Вибір кольору',
  productsLibrary: 'Бібліотека продуктів',
  productsLibraryHint: '— перетягніть продукти у сцену, щоб розмістити їх',
  releaseToPlace: 'Відпустіть, щоб розмістити у сцені',
  noProductsFound: 'Продукти не знайдено',
  composeDisabledMissingModel:
    'Один або декілька вибраних продуктів не мають 3D-моделі',
  productLoadFailed: 'Не вдалося завантажити «{{productName}}» у сцену'
};

export default composer;
